// frontend/src/pages/Auth/ForgotPassword.js

import React, { useState } from 'react';
import axiosInstance from '../../utils/axiosConfig';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axiosInstance.post('/auth/forgot-password', { email });
      setMessage(data.message);
      setError('');
    } catch (err) {
      setError(
        err.response?.data?.message || 'Fehler: Der Link zum Zurücksetzen konnte nicht gesendet werden.'
      );
      setMessage('');
    }
  };

  return (
    <div className="max-w-md mx-auto p-8 bg-white rounded shadow mt-10">
      <h2 className="text-2xl font-heading text-primary mb-4">Passwort vergessen</h2>

      {message && (
        <div className="bg-green-100 text-green-700 p-2 mb-4">{message}</div>
      )}
      {error && (
        <div className="bg-red-100 text-red-700 p-2 mb-4">{error}</div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-semibold mb-1">E-Mail</label>
          <input
            type="email"
            className="w-full p-2 border rounded"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-primary text-white py-2 rounded hover:bg-orange-600"
        >
          Link zum Zurücksetzen senden
        </button>
      </form>
    </div>
  );
};

export default ForgotPassword;
